import React from "react";
import { array, string } from "prop-types";
import { connect } from "react-redux";
import get from "lodash/get";
import assetify from "@quintype/framework/assetify";
import { Link } from "@quintype/components";

import FooterMenuGroup from "../../../molecules/FooterMenuGroup";
import protichintaIcon from "../../../../../assets/images/protichinta-icon.png";
import { Facebook, Twitter } from "../../../atoms/icons/StoryPageIcons";
import { getSocialLinks } from "../../../utils/utils";
import { logoRenderer } from "../../../utils/react-utils";

import "./protichintaFooter.m.css";

const ProtichintaCommunicationList = ({ className = "" }) => (
  <ul styleName="protichinta-communication-list" className={className}>
    <li styleName="communication-text">যোগাযোগ</li>
    <li styleName="anxiety-text">প্রতিচিন্তা</li>
    <li>প্রগতি ইনস্যুরেন্স ভবন</li>
    <li>২০-২১ কারওয়ান বাজার , ঢাকা ১২১৫</li>
    <li>ফোন: ৮১৮০০৭৮-৮১</li>
    <li>ইমেইল: protichinta@gmail.com</li>
  </ul>
);

ProtichintaCommunicationList.propTypes = {
  className: string
};

const ProtichintaFooterBase = ({ protichintaMenuItems, currentPath }) => {
  const menuItems = protichintaMenuItems.find(item => item.title === "footer");
  const socialLinks = getSocialLinks("protichinta");

  return (
    <div styleName="wrapper">
      <div styleName="menu-items-with-logo">
        {logoRenderer(
          <img src={`${assetify(protichintaIcon)}`} alt="protichinta-icon" styleName="protichinta-icon" />,
          currentPath
        )}
        <div styleName={`menu-items-container `}>
          {menuItems && menuItems.children && menuItems.children.length > 0 && (
            <FooterMenuGroup links={menuItems.children.slice(0, 10)} />
          )}
          <ProtichintaCommunicationList className="communication-list-desktop" />
        </div>
      </div>
      <div styleName="about-protichinta">
        <ProtichintaCommunicationList className="communication-list-mobile" />
        <ul styleName="about-protichinta-data">
          <li>© স্বত্ব প্রথম আলো ১৯৯৮ - ২০১৯</li>
          <li>সম্পাদক ও প্রকাশক: মতিউর রহমান</li>
          <li>প্রগতি ইনস্যুরেন্স ভবন, ২০-২১ কারওয়ান বাজার, ঢাকা ১২১৫</li>
          <li>ফোন: ৮১৮০০৭৮-৮১, ফ্যাক্স: ৫৫০১২২০০, ৫৫০১২২১১</li>
          <li>ইমেইল: info@prothomalo.com</li>
        </ul>
        <div styleName="social-icons">
          <Link href={socialLinks.fbUrl}>
            <Facebook color1="#781619" color2="#eee" />
          </Link>
          <Link href={socialLinks.twitterUrl}>
            <Twitter color1="#781619" color2="#eee" />
          </Link>
        </div>
      </div>
    </div>
  );
};

function mapStateToProps(state) {
  return {
    protichintaMenuItems: get(state, ["qt", "data", "navigationMenu", "protichintaMenuItems"], []),
    currentPath: get(state, ["currentPathReducer", "currentPath"], null)
  };
}

ProtichintaFooterBase.propTypes = {
  protichintaMenuItems: array,
  currentPath: string
};

export const ProtichintaFooter = connect(mapStateToProps)(ProtichintaFooterBase);
